import { Button, Form, Input, Modal, Spin } from "antd";
import React, { useState } from "react";
import EditUnitNameApi from "../../../api/units/EditUnitNameApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import { LoadingOutlined } from "@ant-design/icons";

function EditUnitNameModal(props) {
  const [submit, setSubmit] = useState(false);
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    setValuesChanged(false);
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditUnitNameApi(props.unit?.id, value.unitName);

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Unit edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit unit. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Edit unit name"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="editUnit"
        onFinish={onFinish}
        autoComplete="off"
        requiredMark={false}
        layout="vertical"
        initialValues={{
          orgLevel: props.unit?.levelId,
          unitName: props.unit?.name,
          headUnit: props.unit?.headUnitId,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Unit name*" name="unitName">
          <Input placeholder="Unit name" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditUnitNameModal;
